/**
 * Picks v2 or v1 of the Promo Banner edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import PromoBannerAddEditPage   from './PromoBannerAddEditPage';
import PromoBannerAddEditPageV2 from './PromoBannerAddEditPageV2';

export default function PromoBannerAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? PromoBannerAddEditPageV2 : PromoBannerAddEditPage;
  return <Component {...props} />;
}
